import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";
import LocationAdapter from '@javascripts/adapters/location_adapter.js';
import Button from "../button";

export default class Index extends Button {
  constructor(player, options = {}){
    super(player, options);

    // NOTE: SocialModal initialize using timeout since vjs-share-button not ready yet when component "Ready"
    this.setTimeout(() => {
      this.onComponentRendered();
    }, 0);
  }

  createEl() {
    let el = super.createEl();
    el.setAttribute('data-section', 'player');
    el.setAttribute('data-is-premier', this.options_.isPremier);
    el.setAttribute('data-use-ahoy', true);
    el.setAttribute('data-video-id', this.options_.videoId);
    el.setAttribute('data-target-url', LocationAdapter.href());
    return el;
  }

  buildCSSClass() {
    return 'vjs-share-button';
  }

  onComponentRendered(){
    if (window.SocialModal != null){
      this.setupSocialModal();
      this.initSocialModal();
    }
  }

  setupSocialModal(){
    this._socialModal = new window.SocialModal('.vjs-share-button', '.b-social-share-buttons');
  }

  initSocialModal() {
    this._socialModal.init();
  }
}

Index.prototype.controlText_ = "Share";
VideoJsAdapter.registerComponent('VpShareButton', Index);
